export default __webpack_public_path__ + "static/media/note.123c9e62.svg";